import * as Yup from "yup";

enum CompanyProfileKeys {
	id = "id",
	modifiedDate = "modifiedDate",
	createdDate = "createdDate",
	createdBy = "createdBy",
	modifiedBy = "modifiedBy",
	phoneNumber = "phoneNumber",
	companyWebsite = "companyWebsite",
	corporateRssFeed = "corporateRssFeed",
	description = "description",
	companyEmail = "companyEmail",
	salesPhone = "salesPhone",
	salesEmail = "salesEmail",
	partnershipGoals = "partnershipGoals",
	industries = "industries",
	portfolios = "portfolios",
	primaryGoal = "primaryGoal",
	productFamiliarities = "productFamiliarities",
	companyType = "companyType",
	partnershipRequestStatus = "partnershipRequestStatus",
}

enum ProgrammaticTrackingKeys {
	companyLogo = "companyLogo",
	logoAuthorization = "logoAuthorization",
}

export const CompanyProfileValidationSchema: Yup.ObjectSchema = Yup.object().shape({
	programmaticTracking: Yup.object().shape({
		[ProgrammaticTrackingKeys.companyLogo]: Yup.string().required("logo"),
		[ProgrammaticTrackingKeys.logoAuthorization]: Yup.boolean().oneOf([true], "logo auth"),
	}),
	companyProfile: Yup.object().shape({
		[CompanyProfileKeys.companyWebsite]: Yup.string().required("website"),
		[CompanyProfileKeys.industries]: Yup.array().min(1, "industries"),
	}),
});
